<template>
  <v-container
    id="student-detail"
    fluid
    tag="section"
  >
    <!-- <student-care-detail-top-header
      v-if="!loading"
      :studentDuoDetail="studentDuoDetail"
      :typeFilter="typeFilter"
      :filter="filter"
    ></student-care-detail-top-header> -->
    <student-care-top-content
      v-if="!loading && this.checkPermission('student-detail_read')"
      :studentDuoDetail="studentDuoDetail"
      :contactData="contactData"
      :filterForm="filterForm"
      :filter="filterFormDou"
      :studentId="studentId"
    ></student-care-top-content>
    <student-care-bottom-content
      v-if="!loading"
      :studentDuoDetail="studentDuoDetail"
      :studentDuoRelated="studentDuoRelated"
      :contactData="contactData"
      :filterForm="filterForm"
      :listSubjects="listSubjects"
    ></student-care-bottom-content>
  </v-container>
</template>

<script>
import checkPermission from '@/modules/student_care/mixins/checkPermission';
import moment from 'moment';
import { mapActions, mapState } from 'vuex';
import TicketRepository from '@/services/TicketRespository';
// import StudentCareDetailTopHeader from './components/detail/StudentCareDetailTopHeader.vue';
import StudentCareTopContent from './components/detail/StudentCareTopContent.vue';
import StudentCareBottomContent from './components/detail/StudentCareBottomContent.vue';
import StudentCareServices from '../../services/StudentCareServices';

export default {
  components: {
    // StudentCareDetailTopHeader,
    StudentCareTopContent,
    StudentCareBottomContent,
  },
  mixins: [checkPermission],
  data() {
    return {
      studentDuoDetail: {},
      studentDuoRelated: {},
      recordId: '',
      studentId: '',
      contactData: {},
      typeFilter: [
        { name: 'Details', code: 'detail' },
        { name: 'Chart', code: 'chart' },
      ],
      filterForm: {
        subjectId: '',
        lmsCoreUserID: '',
      },
      loading: true,
      listSubjects: [],
      listSubjectsDetail: {},
      filter: {
        dateMonth: '',
        typeViewFilter: 'detail',
      },
    };
  },
  async created() {
    await this.fetchDataCreated();
    Bus.$on('change-contact-child-view', () => {
      this.fetchDataCreated();
    });
    Bus.$on('change-data-top-content-right-subject', async () => {
      const loading = this.$loading.show();
      const params = {
        userId: this.studentDuoDetail.lms_core_user_id,
        startTime: moment(this.filterFormDou.dateTime[0]).format('YYYY-MM-DD'),
        endTime: moment(this.filterFormDou.dateTime[1]).format('YYYY-MM-DD'),
        subjectId: this.filterForm.subjectId,
      };
      if (this.activeClass) {
        await this.getSelfStudyResult(params);
      } else {
        await this.getStudyResult(params);
      }
      // await Promise.all([
      //   this.getSelfStudyResult(params),
      //   this.getStudyResult(params),
      // ]);
      loading.hide();
    });
  },
  beforeDestroy() {
    Bus.$off('change-contact-child-view');
  },
  methods: {
    ...mapActions('duo_care', ['getSelfStudyResult', 'getStudyResult']),
    ...mapActions('student_care', ['getCareContactDetail']),
    ...mapActions('contact_status', ['getListStatus']),
    async getStudentId(id) {
      try {
        const response = await TicketRepository.getStudentIdApi(id);
        if (response.success) {
          this.studentId = response.data;
        } else {
          this.studentId = response.data;
        }
      } catch (e) {
        console.log(e);
      }
    },
    async getDetailStudentDuo() {
      if (!this.recordId) return;
      const res = await StudentCareServices.fgGetListCareBlender({
        obj: 'routine',
        attrs: [
          'id', 'contact_id', 'lms_core_user_id', 'student_id', 'full_name', 'customer_id', 'call_id',
          'call_status_id', 'type_customer_care', 'type_curriculum', 'curriculum_id', 'subject_id',
          'subject_id_list', 'homeroom_teacher_name', 'homeroom_teacher_id', 'student_product_id',
        ],
        'filters[$eq__id]': this.recordId,
      });
      this.studentDuoDetail = res?.data[0];
      if (this.studentDuoDetail && this.studentDuoDetail.lms_core_user_id) {
        await this.getStudentId(this.studentDuoDetail.lms_core_user_id);
      }
      this.filterForm.lmsCoreUserID = this.studentDuoDetail?.lms_core_user_id;
      [this.contactData, this.studentDuoRelated, this.listSubjectsDetail] = await Promise.all([
        this.getCareContactDetail(this.studentDuoDetail?.contact_id),
        this.getRelatedStudentDuo(),
        this.getListSubjectDetail(),
      ]);
    },
    async fetchDataCreated() {
      this.appLoadingData(true, 0);
      this.loading = true;
      this.recordId = this.$route.params?.id;
      this.getListStatus({
        type_curriculum: 'duo',
      });
      this.getFilter();
      await this.getDetailStudentDuo();
      const params = {
        userId: this.studentDuoDetail.lms_core_user_id,
        startTime: moment(this.filterFormDou.dateTime[0]).format('YYYY-MM-DD'),
        endTime: moment(this.filterFormDou.dateTime[1]).format('YYYY-MM-DD'),
        subjectId: this.filterForm.subjectId,
      };
      if (this.activeClass) {
        this.getSelfStudyResult(params);
      } else {
        this.getStudyResult(params);
      }
      // this.getListSubjectDetail();
      this.loading = false;
      this.appLoadingData(false, 0);
    },
    async getListSubjectDetail() {
      const res = await StudentCareServices.getListSubjectDetailv2({
        // userId: this.studentDuoDetail?.lms_core_user_id,
        userId: this.studentDuoDetail?.lms_core_user_id,
      });
      if (res.success) {
        this.listSubjects = this.activeClass === 0 ? res.data.coursesDuo : res.data.coursesSelf;
        this.filterForm.subjectId = this.listSubjects && this.listSubjects.length ? this.listSubjects[0]?.subjectId : '';
        return res.data;
      }
      return [];
    },

    getFilter() {
      if (moment().isBefore(moment().startOf('month').add(4, 'day'))) {
        this.filter.dateMonth = moment().subtract(1, 'month').format('YYYY-MM');
      } else {
        this.filter.dateMonth = moment().format('YYYY-MM');
      }
    },
    async getRelatedStudentDuo() {
      const res = await StudentCareServices.fgGetListCareBlender({
        obj: 'routine',
        attrs: [
          'id', 'contact_id', 'lms_core_user_id', 'student_id', 'full_name', 'customer_id', 'call_id',
          'call_status_id', 'type_customer_care', 'type_curriculum', 'curriculum_id', 'subject_id',
          'subject_id_list',
        ],
        'filters[$eq__contact_id]': this.studentDuoDetail?.contact_id,
        'filters[$eq__lms_core_user_id]': this.studentDuoDetail?.lms_core_user_id,
        'filters[$ne__id]': this.studentDuoDetail?.id,
        'filters[$ne__type_customer_care]': this.studentDuoDetail?.type_customer_care,
      });
      if (res?.success && res?.data.length) {
        return res.data[0];
      }
      return {};
    },
  },
  computed: {
    ...mapState('duo_care', ['filterFormDou', 'childCustomerName', 'activeClass']),
  },
  watch: {
    $route() {
      this.fetchDataCreated();
    },
    async activeClass() {
      this.listSubjects = this.activeClass === 0 ? this.listSubjectsDetail.coursesDuo : this.listSubjectsDetail.coursesSelf;
      this.filterForm.subjectId = this.listSubjects && this.listSubjects.length ? this.listSubjects[0]?.subjectId : '';
      const loading = this.$loading.show();
      const params = {
        userId: this.studentDuoDetail.lms_core_user_id,
        startTime: moment(this.filterFormDou.dateTime[0]).format('YYYY-MM-DD'),
        endTime: moment(this.filterFormDou.dateTime[1]).format('YYYY-MM-DD'),
        subjectId: this.filterForm.subjectId,
      };
      if (this.activeClass) {
        await this.getSelfStudyResult(params);
      } else {
        await this.getStudyResult(params);
      }
      loading.hide();
    },
    filterFormDou: {
      async handler(val) {
        if (this.studentDuoDetail.lms_core_user_id) {
          const diffDays = val.dateTime && val.dateTime.length ? parseInt((new Date(val.dateTime[1]) - new Date(val.dateTime[0])) / (1000 * 60 * 60 * 24), 10) : null;
          if (diffDays && Math.abs(diffDays) > 150) {
            this.$swal({
              type: 'error',
              title: 'Lỗi !',
              text: 'Chỉ lựa chọn khoảng thời gian tối đa 5 tháng !!',
            });
          } else {
            const loading = this.$loading.show();
            const params = {
              userId: this.studentDuoDetail.lms_core_user_id,
              startTime: moment(val.dateTime[0]).format('YYYY-MM-DD'),
              endTime: moment(val.dateTime[1]).format('YYYY-MM-DD'),
              subjectId: this.filterForm.subjectId,
            };
            if (this.activeClass) {
              await this.getSelfStudyResult(params);
            } else {
              await this.getStudyResult(params);
            }
            loading.hide();
          }
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped lang="css">
#student-detail {
  padding: 12px 0px !important;
  padding-right: 27px !important;
}
.col.col-5, .col.col-7 {
  background: white;
}
</style>
